import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/data-element'
const plural = 'dataelements'
const single = 'dataelement'

const dataElements = new ApiCore({
	index: true,
	findOne: false,
	findAll: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

dataElements.massUpdate = () => {
	// Custom API Logic
}

function escapeRegExp(str) {
	return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function markRequiredCsvFields(response) {
	let elementSchema = response?.elementSchema;
	let required = [...(elementSchema?.required ?? [])];

	// check if property is anyOf/oneOf (only check for index 0)
	let keys = ['anyOf', 'oneOf']
	for (let key of keys) {
		if (Array.isArray(elementSchema?.[key]) && elementSchema?.[key]?.length) {
			elementSchema = elementSchema?.[key]?.[0]
			required = [...required, ...(elementSchema?.required ?? [])];
		}
	}

	for (const p in elementSchema?.properties) {
		const deProp = elementSchema.properties?.[p];
		if (deProp?.items?.required) {
			required = [...required, ...deProp.items.required];
		}
	}

	let csvTemplate = response?.csvTemplate
	if (typeof csvTemplate === 'string') {
		required.forEach((prop) => {
			if (csvTemplate.includes(prop)) {
				const escaped = escapeRegExp(prop)
				csvTemplate = csvTemplate
					.replace(new RegExp(`\\b${escaped}\\b,`, "g"), `${prop}*,`)
					.replace(new RegExp(`\\b${escaped}\\b\n`, "g"), `${prop}*\n`)
			}
		});
	}

	return { ...response, csvTemplate }
}

dataElements.getDataElementTemplate = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${encodeURIComponent(id)}`)
		.then((resp) => {
			const response = handleResponse(resp)[1];
			return [undefined, markRequiredCsvFields(response)]
		})
		.catch(handleError);
}

dataElements.getDataElementVersion = (id, version) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/data-element-versions/${encodeURIComponent(id)}/${encodeURIComponent(version)}`)
		.then((resp) => {
			const response = handleResponse(resp)[1];
			return [undefined, response]
		})
		.catch(handleError);
}

dataElements.listActiveVersions = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/data-element-versions`, {
			params: { dataElementId: id, status: 'ACTIVE', all: true },
		})
		.then((resp) => {
			const response = handleResponse(resp)[1];
			const items = Array.isArray(response?.items)
				? response.items
				: Array.isArray(response?.data?.items)
					? response.data.items
					: Array.isArray(response)
						? response
						: null
			if (items === null) {
				// An unrecognised 200 body (e.g. the SPA index.html fallback a stale
				// pitstop-core serves for unregistered routes) must surface as an
				// error, not an empty list — callers treat a confirmed-empty list as
				// "this DE has no ACTIVE version" and block exchange on it.
				return [{ message: 'Unrecognised data-element-versions response shape' }, undefined]
			}
			return [undefined, items]
		})
		.catch(handleError);
}

export default dataElements
